import { lazy, Suspense } from 'react';
import { Outlet, createRoute, SearchSchemaInput } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { NewsPostsListSearchParamsSchema } from 'src/sections/news/view';

import { rootRoute } from './root';

const NewsPostsList = lazy(() => import('src/sections/news/view'));
const NewsPostDetails = lazy(() => import('src/sections/news/detail-view'));

// News routes
const newsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'news',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const newsPostsListRoute = createRoute({
  getParentRoute: () => newsRoute,
  path: '/',
  component: NewsPostsList,
  validateSearch: (search: unknown & SearchSchemaInput) =>
    NewsPostsListSearchParamsSchema.validateSync(search),
});

const newsPostDetailRoute = createRoute({
  getParentRoute: () => newsRoute,
  path: '$newsPostId',
  component: NewsPostDetails,
});

export const newsRouteTree = newsRoute.addChildren([newsPostsListRoute, newsPostDetailRoute]);
